import { SyntheticEvent, useEffect, useMemo } from "react";
import * as React from "react";

import { useAppDispatch, useAppSelector } from "app/hooks";
import ActionSnackbar from "components/action-snackbar";
import {
  selectSnackbarActionType,
  selectSnackbarAdditionalAction,
  selectSnackbarCustomMessage,
  selectSnackbarLabel,
  selectSnackbarOpen,
  selectSnackbarPendingCustomMessage,
  setAdditionalAction,
  setCustomMessage,
  setLabel,
  setOpen,
  setPendingCustomMessage
} from "components/action-snackbar/action-snackbar-slice";

export default function AppSnackbar() {
  const dispatch = useAppDispatch();
  const open = useAppSelector(selectSnackbarOpen);
  const label = useAppSelector(selectSnackbarLabel);
  const customMessage = useAppSelector(selectSnackbarCustomMessage);
  const pendingCustomMessage = useAppSelector(
    selectSnackbarPendingCustomMessage
  );
  const actionType = useAppSelector(selectSnackbarActionType);
  const additionalAction = useAppSelector(selectSnackbarAdditionalAction);
  const onClose = (event: SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") return;
    dispatch(setOpen(false));
  };

  useEffect(() => {
    if (!open) {
      // Clear previous toast metadata first so it doesn't leak into a
      // pending error toast that's about to be drained.
      dispatch(setLabel(""));
      dispatch(setAdditionalAction(undefined));

      if (pendingCustomMessage) {
        dispatch(setCustomMessage(pendingCustomMessage));
        dispatch(setPendingCustomMessage(undefined));
        dispatch(setOpen(true));
      } else {
        dispatch(setCustomMessage(undefined));
      }
    }
  }, [open, pendingCustomMessage, dispatch]);

  const message: string = useMemo(() => {
    if (!open) return "";
    if (customMessage) return customMessage;

    const actionMessage = {
      add: `${label} created`,
      update: `${label} updated`,
      delete: `${label} deleted`,
      cancel: `${label} canceled`
    };

    return actionMessage[actionType];
  }, [open, label, customMessage, actionType]);

  return (
    <ActionSnackbar
      open={Boolean(open)}
      duration={typeof open === "number" ? Number(open) : undefined}
      onClose={onClose}
      message={message}
      additionalAction={additionalAction}
    />
  );
}
